import { render, staticRenderFns } from "./LogoPage.vue?vue&type=template&id=65a05456&scoped=true&"
import script from "./LogoPage.vue?vue&type=script&lang=js&"
export * from "./LogoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a05456",
  null
  
)

export default component.exports